import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Markdown, MarkdownSize } from '@vtblife/react-markdown';
import { Button } from '@vtblife/uikit';
import React from 'react';
import cn from 'classnames';
import styles from './info-step.module.css';
export function InfoStep(props) {
  var _props$buttons = props.buttons,
    buttons = _props$buttons === void 0 ? [] : _props$buttons,
    subtitle = props.subtitle,
    title = props.title,
    imageSrc = props.imageSrc,
    mobileImageSrc = props.mobileImageSrc,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? '6c' : _props$layout,
    imageSize = props.imageSize,
    variant = props.variant;
  return React.createElement("div", {
    className: cn(styles.container, styles["layout-".concat(layout)], styles["image-size-".concat(imageSize)], styles["variant-".concat(variant)], _defineProperty({}, styles.hasImage, !!imageSrc))
  }, React.createElement("div", {
    className: styles.content
  }, imageSrc && React.createElement("picture", {
    className: styles.imageWrap
  }, mobileImageSrc && React.createElement("source", {
    srcSet: mobileImageSrc,
    media: "(max-width: 768px)"
  }), React.createElement("img", {
    src: imageSrc,
    alt: ''
  })), title && React.createElement("div", {
    className: styles.title
  }, React.createElement(Markdown, {
    startHeader: 2,
    source: title,
    minimalHeadingStyleLevel: 2,
    sizeVariant: MarkdownSize.Quiz
  })), subtitle && React.createElement("div", {
    className: styles.subtitle
  }, subtitle)), buttons.length > 0 && React.createElement("div", {
    className: styles.buttons
  }, buttons.map(function (button, i) {
    return React.createElement("div", {
      key: i,
      className: styles.button
    }, React.createElement(Button, {
      variant: button.variant,
      onClick: button.onClick,
      fullWidth: true,
      size: "l",
      href: button.url
    }, button.text));
  })));
}